import React from "react"
import Layout from "../components/Layout"
import { graphql, Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import RenderTags from "../components/RenderTags"
import kebabCase from "lodash/kebabCase"
import SEO from "../components/SEO";
const $ = require("jquery");

class NewsDetail extends React.Component {
        
    componentDidMount() {
        $(".app-section-detailnews").each(function () {
            $(this).show();
        });
    }

    render() {
        const { data } = this.props
        const { html } = data.markdownRemark
        const { title, publishedAt, slug, description, author } = data.markdownRemark.frontmatter
        
        const newsdetail_vi_html = data.newsdetail_vi.html
        const newsdetail_vi_title = data.newsdetail_vi.frontmatter.title
        const newsdetail_vi_author = data.newsdetail_vi.frontmatter.author
        const newsdetail_vi_publishedAt = data.newsdetail_vi.frontmatter.publishedAt
        const newsdetail_vi_description = data.newsdetail_vi.frontmatter.description 

        // const { subTitle, featuredImg } = data.markdownRemark.frontmatter
        // const { group } = data.allMarkdownRemark
        const group_en = data.group_en.group
        const group_vi = data.group_vi.group
        const allposts = data.allposts.nodes
        const allposts_vi = data.allposts_vi.nodes

        let relatedarticle;
        let relatedarticlevi;
        
        function getAllPostsContainContextTags(allposts, tagsdetail) {
            const getallpostsdetail = allposts.map((res) => ( // get all posts detail
                res.frontmatter
            ))
            const detailTagArr = tagsdetail.map((res) => ( // get tags array following context
                res.fieldValue
            ))
            relatedarticle = getallpostsdetail.filter(item => item.tags.some(item => detailTagArr.includes(item))) // get posts that tags property have contained tags in context
            
            return relatedarticle;
        }

        //getAllPostsContainContextTags(allposts, tagsdetail)

        function getAllPostsContainContextTagsVI(allposts_vi, tagsdetailvi) {
            const getallpostsdetail = allposts_vi.map((res) => ( // get all posts detail
                res.frontmatter
            ))
            const detailTagArr = tagsdetailvi.map((res) => ( // get tags array following context
                res.fieldValue
            ))
            relatedarticlevi = getallpostsdetail.filter(item => item.tags.some(item => detailTagArr.includes(item))) // get posts that tags property have contained tags in context
            
            return relatedarticlevi;
        }

        //getAllPostsContainContextTagsVI(allposts_vi, tagsdetailvi)        

        return (
            <Layout>
                <SEO title={title} description={description} meta={[{ name: `keywords`, content: ["news"] }]} pathname={"/news/" + slug} />
                <div className="main-content-padding">
                    {/* <div className="banner-page">
                        <Container>
                            <h1>news</h1>
                            <h2>Main content news</h2>
                        </Container>
                    </div>
                    <div className="news-detail">
                        <Container>
                            <h1>{title}</h1>
                            <h2>{subTitle}</h2>
                            <div className="img-feature">
                                <Img fluid={featuredImg.childImageSharp.fluid} />
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: html }} />
                        </Container>
                    </div> */}
                    <div className="app-general-seciton app-section-detailnews">
                        <Container>
                            <Row>
                                <Col xs={12} md={12} lg={12} xl={1}></Col>
                                <Col xs={12} md={12} lg={12} xl={10}>
                                    <div className="app-data-en app-news-posts-directory">
                                        <h6>
                                            <Link to="/news">
                                                <span>News Home</span>
                                            </Link>
                                        </h6>
                                        <img src="/app-icon-news-posts-directory.svg" alt="app icon news posts directory img" />
                                        <h6>
                                            <span>{title}</span>
                                        </h6>
                                    </div>
                                    <div className="app-data-vi app-news-posts-directory">
                                        <h6>
                                            <Link to="/news">
                                                <span>Tin tức</span>
                                            </Link>
                                        </h6>
                                        <img src="/app-icon-news-posts-directory.svg" alt="app icon news posts directory img" />
                                        <h6>
                                            <span>{newsdetail_vi_title}</span>
                                        </h6>
                                    </div>
                                    <div className="app-detailnews-detail-left">
                                        <h2 className="title app-data-en">{title}</h2>
                                        <h2 className="title app-data-vi">{newsdetail_vi_title}</h2>
                                        <div className="app-detailnews-detail-infor-article">
                                            <div className="app-detailnews-detail-infor-article-left">
                                                {/* <div className="app-detailnews-detail-infor-article-content">
                                                    <img src="/app-icon-user.svg" alt="app icon user" />
                                                    <h6>{author}</h6>
                                                </div> */}
                                                <div className="app-detailnews-detail-infor-article-content">
                                                    {/* <img src="/app-icon-calendar.svg" alt="app icon calendar" /> */}
                                                    <h6 className="app-data-en">{author}, {publishedAt}</h6>
                                                    <h6 className="app-data-vi">{newsdetail_vi_author}, {newsdetail_vi_publishedAt}</h6>
                                                </div>
                                            </div>
                                            {/* <div className="app-detailnews-detail-infor-article-right">
                                                <div className="app-detailnews-detail-infor-article-content">
                                                    <img src="/app-icon-like.svg" alt="app icon like" />
                                                    <h6>60 Likes</h6>
                                                </div>
                                                <div className="app-detailnews-detail-infor-article-content">
                                                    <img src="/app-icon-view.svg" alt="app icon view" />
                                                    <h6>120 Views</h6>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="markdown-body app-data-en" dangerouslySetInnerHTML={{ __html: html }} />
                                        <div className="markdown-body app-data-vi" dangerouslySetInnerHTML={{ __html: newsdetail_vi_html }} />
                                        {/* <div className="app-detailnews-detail-interaction">
                                            <img src="/app-icon-like.svg" alt="app icon like" />
                                            <h6>Like</h6>
                                        </div> */}
                                    </div>
                                </Col>
                                {/* <Col xs={12} md={12} lg={12} xl={3}>
                                    <div className="app-news-detailnews-right">
                                        <h5>Tags</h5>
                                        <div className="app-news-detailnews-right-tag">
                                            <div className="app-data-en">
                                                {tagsdetail.map((res) => (
                                                    <Link to={`/tags/${kebabCase(res.fieldValue)}/`} key={res.fieldValue}>
                                                        {res.fieldValue}
                                                    </Link>
                                                ))}
                                            </div>
                                            <div className="app-data-vi">
                                                {tagsdetailvi.map((res) => (
                                                    <Link to={`/tags/${kebabCase(res.fieldValue)}/`} key={res.fieldValue}>
                                                        {res.fieldValue}
                                                    </Link>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="app-news-detailnews-right">
                                        <h5>Related Articles</h5>
                                        <div className="app-data-en">
                                            {relatedarticle.map((res) => (slug !== res.slug) ? (
                                                <div className="app-news-detailnews-right-author-related-article" key={res.slug}>
                                                    <Link to={"/news/" + res.slug}>
                                                        {res.title}
                                                    </Link>
                                                    <div className="app-news-detailnews-right-author">
                                                        <div className="app-news-detailnews-right-author-infor">
                                                            <img src="/app-icon-user.svg" alt="app icon user" />
                                                            <h6>{res.author}</h6>
                                                        </div>
                                                        <div className="app-news-detailnews-right-calendar-infor">
                                                            <img src="/app-icon-calendar.svg" alt="app icon calendar" />
                                                            <h6>{res.publishedAt}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null)}
                                        </div>
                                        <div className="app-data-vi">
                                            {relatedarticlevi.map((res) => (slug !== res.slug) ? (
                                                <div className="app-news-detailnews-right-author-related-article" key={res.slug}>
                                                    <Link to={"/news/" + res.slug}>
                                                        {res.title}
                                                    </Link>
                                                    <div className="app-news-detailnews-right-author">
                                                        <div className="app-news-detailnews-right-author-infor">
                                                            <img src="/app-icon-user.svg" alt="app icon user" />
                                                            <h6>{res.author}</h6>
                                                        </div>
                                                        <div className="app-news-detailnews-right-calendar-infor">
                                                            <img src="/app-icon-calendar.svg" alt="app icon calendar" />
                                                            <h6>{res.publishedAt}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null)}
                                        </div>
                                    </div>
                                    <div className="app-news-detailnews-right">
                                        <h5>This Author</h5>
                                        <div className="app-data-en">
                                            {authordetail.map((res) => (slug !== res.frontmatter.slug) ? (
                                                <div className="app-news-detailnews-right-author-related-article" key={res.id}>
                                                    <Link to={"/news/" + res.frontmatter.slug}>
                                                        {res.frontmatter.title}
                                                    </Link>
                                                    <div className="app-news-detailnews-right-author">
                                                        <div className="app-news-detailnews-right-author-infor">
                                                            <img src="/app-icon-user.svg" alt="app icon user" />
                                                            <h6>{res.frontmatter.author}</h6>
                                                        </div>
                                                        <div className="app-news-detailnews-right-calendar-infor">
                                                            <img
                                                                src="/app-icon-calendar.svg"
                                                                alt="app icon calendar"
                                                            />
                                                            <h6>{res.frontmatter.publishedAt}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null )}
                                        </div>
                                        <div className="app-data-vi">
                                            {authordetailvi.map((res) => (slug !== res.frontmatter.slug) ? (
                                                <div className="app-news-detailnews-right-author-related-article" key={res.id}>
                                                    <Link to={"/news/" + res.frontmatter.slug}>
                                                        {res.frontmatter.title}
                                                    </Link>
                                                    <div className="app-news-detailnews-right-author">
                                                        <div className="app-news-detailnews-right-author-infor">
                                                            <img src="/app-icon-user.svg" alt="app icon user" />
                                                            <h6>{res.frontmatter.author}</h6>
                                                        </div>
                                                        <div className="app-news-detailnews-right-calendar-infor">
                                                            <img
                                                                src="/app-icon-calendar.svg"
                                                                alt="app icon calendar"
                                                            />
                                                            <h6>{res.frontmatter.publishedAt}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null )}
                                        </div>
                                    </div>
                                    <div className="app-news-detailnews-right">
                                        <div className="app-data-en">
                                            <RenderTags group={group_en} />
                                        </div>
                                        <div className="app-data-vi">
                                            <RenderTags group={group_vi} />
                                        </div>
                                    </div>
                                </Col> */}
                                <Col xs={12} md={12} lg={12} xl={1}></Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </Layout>
        )
    }
}

export default NewsDetail

export const query = graphql`
    query NewsDetail($slug: String) {
        markdownRemark(frontmatter: { slug: { eq: $slug }, directory: { eq: "news_all_posts" } }) {
            html
            frontmatter {
                title
                subTitle
                publishedAt(formatString: "MMM DD, yyyy")
                slug
                description
                author
            }
        }
        newsdetail_vi: markdownRemark(frontmatter: { slug: { eq: $slug }, directory: { eq: "news_all_posts_vi" } }) {
            html
            frontmatter {
                title
                subTitle
                publishedAt(formatString: "MMM DD, yyyy")
                slug
                description
                author
            }
        }
        tagsdetail: allMarkdownRemark(
            filter: { frontmatter: { slug: { eq: $slug }, directory: { eq: "news_all_posts" } } }
        ) {
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
        tagsdetail_vi: allMarkdownRemark(
            filter: { frontmatter: { slug: { eq: $slug }, directory: { eq: "news_all_posts_vi" } } }
        ) {
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
        allposts: allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_all_posts" } }, fields: { draft: { eq: false } } }
            sort: { fields: frontmatter___publishedAt, order: DESC }
        ) {
            nodes {
                html
                frontmatter {
                    title
                    publishedAt(formatString: "MMM DD, yyyy")
                    slug
                }
                id
            }
        }
        allposts_vi: allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_all_posts_vi" } }, fields: { draft: { eq: false } } }
            sort: { fields: frontmatter___publishedAt, order: DESC }
        ) {
            nodes {
                html
                frontmatter {
                    title
                    publishedAt(formatString: "MMM DD, yyyy")
                    slug
                }
                id
            }
        }
        group_en: allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_all_posts" } }, fields: { draft: { eq: false } } }
        ) {
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
        group_vi: allMarkdownRemark(
            filter: { frontmatter: { directory: { eq: "news_all_posts_vi" } }, fields: { draft: { eq: false } } }
        ) {
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
    }
`
